export default __webpack_public_path__ + "static/media/ac2oTeam.1200a5a8.webp";